import { useEffect } from "react";
import type { DateRange } from "react-day-picker";

import type { MapPosition } from "@locators/components/shared/hooks/useFlotiqStores/useFlotiqStores.types";

import { convertEventsFiltersToURLObj } from "../utils/convertEventsFilterData";

type UseEventsFiltersShareParams = {
  mapPosition?: MapPosition;
  dateRange?: DateRange;
  isInEditor?: boolean;
};

export const useEventsFiltersShare = (params: UseEventsFiltersShareParams) => {
  const { mapPosition, dateRange, isInEditor } = params;

  useEffect(() => {
    if (isInEditor) return;

    const url = new URL(window.location.href);
    url.search = new URLSearchParams(convertEventsFiltersToURLObj(mapPosition, dateRange)).toString();

    window.history.replaceState({}, "", url);
  }, [mapPosition, dateRange, isInEditor]);
};
